'use strict';

class JSPropsUpdaterWeb {
  registerComponent(_animatedComponent) {
    // noop
  }
  unregisterComponent(_animatedComponent) {
    // noop
  }
  updateProps(_operations) {
    // noop
  }
}
const jsPropsUpdater = new JSPropsUpdaterWeb();
export default jsPropsUpdater;
//# sourceMappingURL=JSPropsUpdater.js.map